//Library Imports
import { connect } from "react-redux";
import { useRef, useState } from "react";

// application components goes here
import { IDesignArticleItem } from "../Interfaces";
import Checkbox from "../../Common/Components/Checkbox";
import MinusIcon from "../../../assets/img/CuratedContent/Minus-ContentIcon.svg";
import MoreMenu from "../../../assets/img/CuratedContent/More-Menu.svg";
import AddIcon from "../../../assets/img/icons/addicon.svg";

// styles goes here
import styled from "styled-components";
import { useEffect } from "react";
import { getImageUrl } from "utils";

interface IArticleProps {
  article: IDesignArticleItem;
  dataIndex: number;
}

const Article = (props: IArticleProps) => {
  const { article_id, article_title, article_image, article_domain, article_is_curated, article_entities } =
    props.article;
  const [ImgWidth, setImgWidth] = useState<number>(0);
  const [ImgHeight, setImgHeight] = useState<number>(0);
  const ImgDimensionsRef = useRef<any>();

  // This function calculates width and height of the list
  const getImgSize = () => {
    const newWidth = ImgDimensionsRef?.current?.clientWidth;
    setImgWidth(newWidth);

    const newHeight = ImgDimensionsRef?.current?.clientHeight;
    setImgHeight(newHeight);
  };

  // Update 'width' and 'height' when the window resizes
  useEffect(() => {
    getImgSize();
    window.addEventListener("resize", getImgSize);
  }, []);
  return (
    <Wrapper>
      <div
        className="wrapper single-article-wrap sidebar-article"
        data-id={article_id.toString()}
        id={"001122-" + article_id.toString()}
        data-index={props.dataIndex}
        data-article-list="data-article-list"
      >
        <div className="content-div">
          <div className="plus-icon-wrapper added">
            <Checkbox
              key={"chk-" + props.dataIndex}
              id={"article-001122-" + article_id}
              className="personalize_articles_stripo"
            />
            <img src={MinusIcon} className="add-icon add-icon-remove" alt="remove blog" />
            <img src={AddIcon} className="add-icon add-icon-add" alt="add blog" />
          </div>
          <div className="blog-image img-wrap">
            <img
              src={getImageUrl(
                article_image,
                ImgWidth > 0 ? ImgWidth : 50,
                ImgHeight > 0 ? ImgHeight : 50,
                article_id
              )}
              alt=""
            />
          </div>
          <div className="content padding-right-sm padding-left-sm">
            <div className="content-inner-wrapper">
              <h4 className="title margin-bottom-xs">{article_title}</h4>
            </div>
            <div className="desc">
              <span className="website-link padding-sm">{article_domain}</span>
              {/* |<span className="published-time padding-sm">{article_entities?.toString()}</span> */}
            </div>
          </div>
          <div className="Blog-menu-icon d-flex">
            <img src={MoreMenu} alt="menu" className="padding-sm" />
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default connect()(Article);

const Wrapper = styled.div`
  .wrapper {
    background-color: #f7f7f7;
    border-radius: 10px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 6px;
    padding-bottom: 6px;
    position: relative;
    margin-bottom: 5px;
    cursor: grab;
    .content-div {
      padding-top: 0.5em;
      padding-bottom: 0.5em;
      padding-left: 0px;
      padding-right: 0px;
      display: flex;
      .content {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        overflow-wrap: anywhere;
        flex-grow: 1;
      }
      .plus-icon-wrapper {
        display: flex;
        align-items: center;
        padding-right: 8px;
        cursor: pointer;
        width: 35px;
        label {
          position: absolute;
          left: 8px;
          top: -9px;
          opacity: 0;
        }
        img {
          max-width: 20px;
          max-height: 20px;
        }
        .add-icon.add-icon-add {
          display: inline-block;
        }
        .add-icon.add-icon-remove {
          display: none;
        }
        &.added {
          .add-icon.add-icon-remove {
            display: inline-block;
          }
          .add-icon.add-icon-add {
            display: none;
          }
        }
      }
      .blog-image {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .blog-image img {
        height: 70px;
        width: 70px;
        border-radius: 10px;
        position: relative;
        overflow: hidden;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          height: 40px;
          width: 40px;
          border-radius: 6px;
        }
        &:before{
          content:"";
          background-image: url("https://media.xiq.io/static/default_campaign_img.png");
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          height: 70px;
          width: 70px;
          border-radius: 10px;
          position: absolute;
          z-index: 2;
          top: 0px;
          left: 0;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            height: 40px;
            width: 40px;
            border-radius: 6px;
          }
        }
      }
      .title {
        font-family: roboto_slabregular, sans-serif;
        font-size: 16px;
        color: #000000;
        margin: 0;
        padding: 0;
        font-weight: bold;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-weight: normal;
          font-size: 12px;
        }
      }
      .desc {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 8px;
        }
      }
      .website-link {
        color: #db3725;
        font-family: "robotomedium", sans-serif;
        font-size: 10px;
        font-weight: 500;
        padding-left: 0;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 8px;
        }
      }
      .published-time {
        color: #7e7e7e;
        font-size: 10px;
        font-family: "robotomedium", sans-serif;
        font-weight: 500;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 8px;
        }
      }
      .tags {
        color: #7e7e7e;
        font-size: 10px;
        font-family: "robotomedium", sans-serif;
        font-weight: 500;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 8px;
        }
      }
      .Blog-menu-icon {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .Blog-menu-icon img {
        cursor: pointer;
        .ant-popover .ant-popover-content .ant-popover-inner {
          border-radius: 10px;
        }
      }
    }
  }
  .disabled {
    pointer-events: none;

    /* for "disabled" effect */
    opacity: 0.5;
    background: #ccc;
  }
  .remove-failed {
    /* for "disabled" effect */
    opacity: 1;
    background: #facfcf;
  }
`;
